// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.click_css[data-v-7919d137]{\n  color: #337ab7;\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
